import React, { useEffect, useState } from 'react';
import { CapaNotificationsOutput } from '@generated/graphql';
import NotificationPopper from './NotificationPopper';
import {
  Badge,
  ClickAwayListener,
  Grid,
  IconButton,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import clsx from 'clsx';
import { NotificationsOutlined } from '@material-ui/icons';
import { useStyles } from './useStyles';

interface Props {
  refetch: () => void;
  data?: CapaNotificationsOutput;
  onReadNotification: (seq: number) => void;
  onReadAllNotification: () => void;
  onClearNewNotification: () => void;
}

const NotificationPresenter: React.FC<Props> = ({
  refetch,
  data,
  onReadNotification,
  onReadAllNotification,
  onClearNewNotification
}) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const notificationCount = data?.data?.count ?? 0;

  const onClose = () => setIsOpen(false);

  useEffect(() => {
    if (isOpen) {
      refetch();
    }
  }, [isOpen, refetch]);

  return (
    <ClickAwayListener
      onClickAway={(e) => {
        e.stopPropagation();
        onClose();
      }}
    >
      <div>
        <NotificationPopper
          data={data}
          open={isOpen}
          anchorEl={anchorEl}
          onClose={onClose}
          onReadNotification={(seq: number) => {
            onClose();
            onReadNotification(seq);
          }}
          onReadAllNotification={() => {
            onClose();
            onReadAllNotification();
          }}
        />
        <Grid container>
          <IconButton
            className={clsx(classes.iconButton, 'gnb-notification-icon')}
            onClick={(e) => {
              if (e.currentTarget) {
                setAnchorEl(e.currentTarget);
                if (isOpen) {
                  setIsOpen(false);
                } else {
                  setIsOpen(true);
                  onClearNewNotification();
                }
              }
            }}
          >
            <Badge
              variant={matches ? 'dot' : 'standard'}
              color="error"
              max={99}
              badgeContent={notificationCount}
            >
              <NotificationsOutlined className={classes.bellSvg} />
            </Badge>
          </IconButton>
        </Grid>
      </div>
    </ClickAwayListener>
  );
};

export default NotificationPresenter;
